import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LandingService } from '../landing.service';
import { Partners } from '../../../../models/partners.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-grupo-beneficios',
  templateUrl: './grupo-beneficios.component.html',
  styleUrls: ['./grupo-beneficios.component.scss']
})
export class GrupoBeneficiosComponent implements OnInit {
  url = environment.URL_AWS;
  beneffits: any[] = [];
  sponsors: any[] = [];
  mesaDirectiva: any[] = [];
  paginatedBeneffits: any[] = [];
  paginatedSponsors: any[] = [];

  search: string;
  bandShow: boolean
  domainPage: string;
  currentPage: number = 1;
  pageSize: number = 4; // Muestra 4 partners por página

  constructor(private _LandingService: LandingService) {
    this.bandShow = true;

    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
  }

  ngOnInit(): void {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
    // this.domainPage = "sanluispotosi";

    console.log("este es el dominio", this.domainPage);
    this._LandingService.getServer('benefits', this.domainPage).then(
      (resp: Partners[]) => {
        this.beneffits = resp;
        this.getPageData();
        console.log("estos son los beneficios",this.beneffits);
      }, (err: any) => {
        console.log("ERROR ", err);
      }
    );

    this._LandingService.getServer('sponsors', this.domainPage).then(
      (resp: Partners[]) => {
        this.sponsors = resp;
        this.getPageData();
        console.log(this.sponsors);
      }, (err: any) => {
        console.log("ERROR ", err);
      }
    );
  }
  

  searchSponsors() {
    this.bandShow = false;
    this.paginatedSponsors = this.sponsors;

    this.paginatedSponsors = this.sponsors.filter(x => x.name.toUpperCase().includes(this.search.toUpperCase()));

    console.log("patrocinadores", this.sponsors);

    setTimeout(() => {
      this.bandShow = true;
    }, 100);

  }

  // searchPartners() {
  //   console.log("este es el search", this.search);
  //   this.bandShow = false;

  //   this.partners = this.partners.filter(x => x.name.toUpperCase().includes(this.search.toUpperCase()));
  //   this.getPageData();
  //   console.log("partners", this.partners);

  //   setTimeout(() => {
  //     this.bandShow = true;
  //   }, 100);

  // }


  getPageData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.paginatedBeneffits = this.beneffits.slice(startIndex, startIndex + this.pageSize);
    this.paginatedSponsors = this.sponsors.slice(startIndex, startIndex + this.pageSize);
  }

  goToPage(page: number): void {
    this.currentPage = page;
    this.getPageData();
  }

  public swiperResponsive: SwiperConfigInterface = {

    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 5,

    // init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: true,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    },
  };

  sendWhatsApp(phone: number): void {
    window.open("https://wa.me/52" + phone, "_blank");
  }

  sendWebPage(page: string): void {

    if (page) {
      window.open(page, "_blank");
    }
  }
  tarjetaDigital(page: string): void {

    if (page) {
      window.open(page, "_blank");
    }
  }
  // searchAffiliates() {
  //   this.bandShow = false;
  //   this.paginatedAffiliates = this.affiliates;

  //   this.paginatedAffiliates = this.affiliates.filter(x => x.name.toUpperCase().includes(this.search.toUpperCase()));

  //   console.log("afiliados", this.affiliates);

  //   setTimeout(() => {
  //     this.bandShow = true;
  //   }, 100);

  // }
}
